export enum STORAGE_KEYS {
  ACCESS_TOKEN = 'ACCESS_TOKEN',
  REFRESH_TOKEN = 'REFRESH_TOKEN',
  DARK_THEME = 'DARK_THEME',
  NAVBAR_OPEN = 'NAVBAR_OPEN',
  REFERRAL_ID = 'REFERRAL_ID_TRACKGOOD',
  LAST_ROUTE = 'LAST_ROUTE_TRACKGOOD',
}

export enum QUERY_KEYS {
  AUTH_USER = 'AUTH_USER',
  AUTH_USER_2FA_EMAIL_TIME = 'AUTH_USER_2FA_EMAIL_TIME',
  GET_STEP = 'GET_STEP',
  GET_JOURNEY = 'GET_JOURNEY',
  GET_IMPACT = 'GET_IMPACT',
  GET_IMPACT_SCAN_TO_EARN_INFO = 'GET_IMPACT_SCAN_TO_EARN_INFO',
  GET_PRODUCT = 'GET_PRODUCT',
  PRODUCT_URL = 'PRODUCT_URL',
  ACCOUNT_URL = 'ACCOUNT_URL',
  GET_USER = 'GET_USER',
  GET_LIBRARY_IMPACT = 'GET_LIBRARY_IMPACT',
  IMPACTS = 'IMPACTS',
  STEP_IMPACTS = 'STEP_IMPACTS',
  JOURNEYS = 'JOURNEYS',
  JOURNEYS_ALL_RAW = 'JOURNEYS_ALL_RAW',
  PRODUCTS = 'PRODUCTS',
  PRODUCTS_ALL = 'PRODUCTS_ALL',
  STEPS = 'STEPS',
  ACCOUNT_STEPS_CONNECTION = 'ACCOUNT_STEPS_CONNECTION',
  STEP_ACCOUNTS_CONNECTION = 'STEP_ACCOUNTS_CONNECTION',
  STEPS_ALL_RAW = 'STEPS_ALL_RAW',
  USER = 'USER',
  USERS = 'USERS',
  USER_WALLET_TOTAL = 'USER_WALLET_TOTAL',
  USER_WALLET_ADDRESS = 'USER_WALLET_ADDRESS',
  USER_PROVIDERS = 'USER_PROVIDERS',
  USER_REFERRALS = 'USER_REFERRALS',
  VERIFY_TOKEN = 'VERIFY_TOKEN',
  GENERATE_DESCRIPTION = 'GENERATE_DESCRIPTION',
  GENERATE_ASSISTANT_MESSAGE = 'GENERATE_ASSISTANT_MESSAGE',
  WEB_CHATBOT_HISTORY = 'WEB_CHATBOT_HISTORY',
  ACCOUNTS = 'ACCOUNTS',
  ACCOUNTS_ALL = 'ACCOUNTS_ALL',
  ACCOUNTS_ALL_RAW = 'ACCOUNTS_ALL_RAW',
  ACCOUNT = 'ACCOUNT',
  ACCOUNT_SUBSCRIPTION_PLAN = 'ACCOUNT_SUBSCRIPTION_PLAN',
  ACCOUNT_USERS = 'ACCOUNT_USERS',
  ACCOUNT_SCANNERS = 'ACCOUNT_SCANNERS',
  ACCOUNT_PAYMENT_METHODS = 'ACCOUNT_PAYMENT_METHODS',
  ACCOUNTS_INVOICES = 'ACCOUNTS_INVOICES',
  ACCOUNT_TRANSACTIONS = 'ACCOUNT_TRANSACTIONS',
  ACCOUNT_SUBSCRIPTION_INFO = 'ACCOUNT_SUBSCRIPTION_INFO',
  ACCCOUNT_LANGUAGES = 'ACCCOUNT_LANGUAGES',
  ACCCOUNT_LANGUAGES_IDS = 'ACCCOUNT_LANGUAGES_IDS',
  LIBRARY_IMPACTS = 'LIBRARY_IMPACTS',
  QUANTITY_TYPES = 'QUANTITY_TYPES',
  QUANTITY_TYPE_CATEGORIES = 'QUANTITY_TYPE_CATEGORIES',
  QUANTITY_TYPE_CATEGORY_CHANGES = 'QUANTITY_TYPE_CATEGORY_CHANGES',
  QUANTITY_TYPES_CHANGES = 'QUANTITY_TYPES_CHANGES',
  UN_SDGS = 'UN_SDGS',
  UN_SDG_CHANGES = 'UN_SDG_CHANGES',
  IMPACT_PERIODS = 'IMPACT_PERIODS',
  IMPACT_PERIOD_CHANGES = 'IMPACT_PERIOD_CHANGES',
  IMPACT_TYPES = 'IMPACT_TYPES',
  ACCOUNT_INDUSTRIES = 'ACCOUNT_INDUSTRIES',
  IMPACT_TYPE_CHANGES = 'IMPACT_TYPES_CHANGES',
  ACCOUND_INDUSTRY_CHANGES = 'ACCOUNT_INDUSTRY_CHANGES',
  CHANGES = 'CHANGES',
  ERROR_LOGS = 'ERROR_LOGS',
  EMAIL_LOGS = 'EMAIL_LOGS',
  TRANSACTION_LOGS = 'TRANSACTION_LOGS',
  USERS_SESSIONS = 'USERS_SESSIONS',
  ACCOUNT_VIEWS = 'ACCOUNT_VIEWS',
  PRODUCTS_VIEWS = 'PRODUCTS_VIEWS',
  IMPACTS_LIKES = 'IMPACTS_LIKES',
  IMPACT_LIKES = 'IMPACT_LIKES',
  PRODUCT_VIEWS = 'PRODUCT_VIEWS',
  MEDIA_LIST = 'MEDIA_LIST',
  MEDIA_CONNECTIONS = 'MEDIA_CONNECTIONS',
  ACCOUNT_COUNTRIES_VIEWS = 'ACCOUNT_COUNTRIES_VIEWS',
  ACCOUNT_TOTAL_VIEWS = 'ACCOUNT_TOTAL_VIEWS',
  ACCOUNT_DAILY_AVERAGE_VIEWS = 'ACCOUNT_DAILY_AVERAGE_VIEWS',
  ACCOUNT_TOP_ITEMS = 'ACCOUNT_TOP_ITEMS',
  LANGUAGES = 'LANGUAGES',
  TRANSLATIONS = 'TRANSLATIONS',
  TRANSLATION_HELPER_TEXT_STATUS = 'TRANSLATION_HELPER_TEXT_STATUS',
  LOGIN_TYPES = 'LOGIN_TYPES',
  DEFAULT_TRANSLATION = 'DEFAULT_TRANSLATION',
  STOCK_IMAGES = 'STOCK_IMAGES',
  STOCK_VIDEOS = 'STOCK_VIDEOS',
  HEALTH_CHECK = 'HEALTH_CHECK',
  SERVER_HEALTH_CHECK = 'SERVER_HEALTH_CHECK',
  TOTP_URI = 'TOTP_URI',
  SUBSCRIPTION_PRICES = 'SUBSCRIPTION_PRICES',
  SUBSCRIPTION_PRICES_OPTIONAL = 'SUBSCRIPTION_PRICES_OPTIONAL',
  DEFAULT_SUBSCRIPTION_PRICES = 'DEFAULT_SUBSCRIPTION_PRICES',
  ACCOUNT_SUBSCRIPTION_PRICES = 'ACCOUNT_SUBSCRIPTION_PRICES',
  ACCOUNT_DEFAULT_SUBSCRIPTION_PRICES = 'ACCOUNT_DEFAULT_SUBSCRIPTION_PRICES',
  SCAN_PRODUCTS = 'SCAN_PRODUCTS',
  SCAN_ACCOUNTS = 'SCAN_ACCOUNTS',
  SCAN_STEPS = 'SCAN_STEPS',
  SCAN_PRODUCT_IMPACT = 'SCAN_PRODUCT_IMPACT',
  SCAN_PRODUCT_IMPACTS = 'SCAN_PRODUCT_IMPACTS',
  SCAN_ACCOUNT_IMPACT = 'SCAN_ACCOUNT_IMPACT',
  SCAN_ACCOUNT_IMPACTS = 'SCAN_ACCOUNT_IMPACTS',
  SCAN_CREATE_INITIAL = 'SCAN_CREATE_INITIAL',
  SCAN_DRAFTS = 'SCAN_DRAFTS',
  SCAN_DRAFTS_COUNT = 'SCAN_DRAFTS_COUNT',
  SCANS = 'SCANS',
  SCANS_STATUS_COUNT = 'SCANS_STATUS_COUNT',
  SCANS_UNREVIEWED_COUNT = 'SCANS_UNREVIEWED_COUNT',
  SCAN_REFERENCE_IDS = 'SCAN_REFERENCE_IDS',
  SCAN_BATCH_IDS = 'SCAN_BATCH_IDS',
  STEP_INITIAL_CODE = 'STEP_INITIAL_CODE',
  PRODUCT_INITIAL_CODE = 'PRODUCT_INITIAL_CODE',
  JOURNEY_INITIAL_CODE = 'JOURNEY_INITIAL_CODE',
  IMPACT_INITIAL_CODE = 'IMPACT_INITIAL_CODE',
  ACCOUNT_STYLES = 'ACCOUNT_STYLES',
  SETTINGS = 'SETTINGS',
  COMMON_SETTINGS = 'COMMON_SETTINGS',
  SETTINGS_SIGN_UP = 'SETTINGS_SIGN_UP',
  SETTINGS_CHECK_MATIC_LOW_BALANCE = 'SETTINGS_CHECK_MATIC_LOW_BALANCE',
  USER_ADDRESS_AND_BALANCE = 'ADDRESS_AND_BALANCE',
  REDIRECT_URLS = 'REDIRECT_URLS',
  SUBSCRIPTION = 'SUBSCRIPTION',
  JOURNEYS_STEPS_ORDER = 'JOURNEYS_STEPS_ORDER',
  WHITE_LABEL_PARTNERS = 'WHITE_LABEL_PARTNERS',
  RATING_SETTINGS = 'RATING_SETTINGS',
  AUTH_TOKEN = 'AUTH_TOKEN',
  CRONE_JOBS = 'CRONE_JOBS',
  SCAN_TO_EARN_PRICE = 'SCAN_TO_EARN_PRICE',
  CONSUMER_SCANS = 'CONSUMER_SCANS',
  CONSUMER_SCAN_ITEM = 'CONSUMER_SCAN_ITEM',
  CONSUMER_SCAN_ACCOUNTS = 'CONSUMER_SCAN_ACCOUNTS',
  CHALLENGES = 'CHALLENGES',
  CHALLENGE_INFO = 'CHALLENGE_INFO',
  CHALLENGES_ACTIVE = 'CHALLENGES_ACTIVE',
  REWARD_POINTS = 'REWARD_POINTS',
  DEFAULT_REWARD_POINTS = 'DEFAULT_REWARD_POINTS',
  REWARD_ACTIVITY = 'REWARD_ACTIVITY',
  REWARD_ACTIVITY_TYPES = 'REWARD_ACTIVITY_TYPES',
  REWARD_ACTIVITY_CHALLENGES = 'REWARD_ACTIVITY_CHALLENGES',
  SCAN_TO_EARN_MANNAGEMENT_SCANNERS = 'SCAN_TO_EARN_MANNAGEMENT_SCANNERS',
  SCAN_TO_EARN_PRODUCT_TYPES = 'SCAN_TO_EARN_PRODUCT_TYPES',
  DECLINE_REASONS = 'DECLINE_REASONS',
  DECLINE_REASONS_OPTIONS = 'DECLINE_REASONS_OPTIONS',
  APPROVAL_FEEDBACKS = 'APPROVAL_FEEDBACKS',
  APPROVAL_FEEDBACKS_BY_IDS = 'APPROVAL_FEEDBACKS_BY_IDS',
  APPROVAL_FEEDBACKS_OPTIONS = 'APPROVAL_FEEDBACKS_OPTIONS',
  AVAIABLE_MODELS = 'AVAIABLE_MODELS',
  FAKE_CONSUMER_SCANS_DATA = 'FAKE_CONSUMER_SCAN_DATA',
}

export enum WS_EVENTS_KEYS {
  USER_ONLINE = 'user-online',
  SCAN_USER_TRANSACTION_EVENT = 'subscribeToUserTransactionEvent',
  SCAN_USER_TRANSACTION_EVENT_UPDATE = 'userTransactionStatusUpdate',
  SCAN_ACCOUNT_TRANSACTION_EVENT = 'subscribeToAccountTransactionEvent',
  SCAN_ACCOUNT_TRANSACTION_EVENT_UPDATE = 'accountTransactionStatusUpdate',
}

export enum WS_NAMESPACES_KEYS {
  USER_ONLINE_STATUS = 'user-online-status',
  EVENTS_NAMESPACE = 'events',
}

export enum WS_TRANSACTION_STATUS {
  IDLE = 'idle',
  PENDING = 'pending',
  SUCCESS = 'success',
  FAILED = 'failed',
}

export enum ROUTES {
  ACCOUNT_SUSPENDED = 'suspended',
  ACCOUNTS_ID = 'accounts/:accountId',
  DASHBOARD = 'dashboard',
  DASHBOARD_WELCOME = 'dashboard/welcome',
  PRODUCTS_VIEWS = 'dashboard/products/views',
  IMPACTS_LIKES = 'dashboard/impacts/likes',
  SINGLE_PRODUCT = 'singleProduct',
  JOURNEYS = 'journeys',
  JOURNEYS_ID = 'journeys/:id',
  JOURNEYS_ADD = 'journeys/add',
  IMPACTS = 'impacts',
  IMPACTS_ID = 'impacts/:id',
  IMPACTS_ADD = 'impacts/add',
  STEPS = 'steps',
  STEPS_ID = 'steps/:id',
  STEPS_ADD = 'steps/add',
  PRODUCTS = 'products',
  PRODUCTS_ID = 'products/:id',
  PRODUCTS_ADD = 'products/add',
  PRODUCTS_ID_QR = 'products/:id/qr-code',
  PRODUCTS_ID_HISTORY = 'products/:id/history',
  DEVICES = 'devices',
  ACCOUNT = 'account',
  ACCOUNT_SUPPORT = 'support',
  ACCEPT_ACCOUNT_INVITE = 'accept-account-invite',
  ACCEPT_ACCOUNT_OWNERSHIP = 'accept-account-ownership',
  APPROVE_STEP_ACCOUNT_CONNECTION = 'approve-step-account-connection',
  SCANS_DASHBOARD = 'scans/create/camera',
  SCANS_CREATE = 'scans/create',
  SCAN_HISTORY = 'scans/history',
  SCANS_DRAFTS = 'scans/drafts',
  SCANS_CAMERA_CREATE = 'scans/create/camera',

  // Consumer routes (USER is distinguished path to recognize consumer routes from others)
  USER = 'user',

  SCAN_TO_EARN = 'scan-to-earn',
  USER_DASHBOARD = `dashboard`,
  TRAICY_CHATBOT = 'traicy',
  LEADERBOARD = 'leaderboard',
  CHALLENGES_USER = 'challenges',
  INVITE_FRIENDS = 'invite',
  SUPPORT = 'support',

  ACCOUNTS = 'accounts',
  ACCOUNTS_ADD = 'accounts/add',
  PROFILE = 'profile',
  SUSPENDED = 'suspended',

  LOGIN = '/signin',
  LOGIN_TOKEN = '/signin/:token',
  LOGIN_EMAIL = '/signin/email',
  LOGIN_EMAIL_VERIFY = '/signin/email/:token',
  LOGIN_2FA_VERIFY = '/signin/2fa/verify',
  REGISTER_EMAIL = '/register/email/:token',
  REGISTER = '/register',
  REGISTER_TOKEN = '/register/:token',
  REGISTER_FINISH = '/register/finish',
  REGISTER_FINISH_TOKEN = '/register/finish/:token',
  FORGOT_PASSWORD = '/forgot-password',
  FORGOT_PASSWORD_VERIFY = '/forgot-password/:token',
  RESET_PASSWORD = '/reset-password/:token',

  INVITE_FRIEND_REDIRECT = 'r',
  INVITE_FRIEND_REFERRAL_ID = ':referralId',

  ACCOUNTS_ALL = 'admin/accounts/all',
  PRODUCTS_ALL = 'admin/products/all',
  USERS = 'admin/users',
  ADMIN_ROUTES = 'admin/routes',
  IMPACTS_LIBRARY = 'admin/impacts-library',
  IMPACTS_LIBRARY_ADD = 'admin/impacts-library/add',
  IMPACTS_LIBRARY_ID = 'admin/impacts-library/:libraryImpactId',
  QUANTITY_TYPES = 'admin/quantity-types',
  QUANTITY_TYPES_CATEGORIES = 'admin/quantity-types/categories',
  UN_SDG = 'admin/un-sdg',
  IMPACT_TYPES = 'admin/impact-types',
  ACCOUNT_INDUSTRIES = 'admin/account-industries',
  SUBSCRIPTION_PRICES = 'admin/subscription-prices',
  SETTINGS = 'admin/settings',
  IMPACT_PERIODS = 'admin/impact-periods',
  CHANGES = 'admin/logs/changes',
  TRANSACTION_LOGS = 'admin/logs/transactions',
  ERROR_LOGS = 'admin/logs/errors',
  EMAIL_LOGS = 'admin/logs/emails',
  USER_SESSIONS = 'admin/logs/user-sessions',
  LANGUAGES = 'admin/languages',
  LANGAUGE_TRANSLATIONS = 'admin/languages/translations',
  HEALTH_CHECK = 'admin/health-check',
  MEDIA_VAULT = 'admin/media',
  HEALTH_CHECK_EXTERNAL = 'health-check',
  REDIRECT_URLS = 'redirect-urls',
  LOGIN_TYPES = 'login-types',
  WHITE_LABEL_PARTNERS = 'white-label-partners',
  CRON_JOBS = 'admin/cron-jobs',
  RATING_SETTINGS = 'admin/rating',
  REWARD_POINTS = 'admin/reward-points',
  CHALLENGES = 'admin/challenges',
  DECLINE_REASONS = 'admin/decline-reasons',
  APPROVAL_FEEDBACKS = 'admin/approval-feedbacks',
  SCAN_TO_EARN_MANAGEMENT = 'admin/scan-to-earn',
  ADMIN_TOOLS = 'admin/tools',

  MAINTENANCE = '/maintenance',
}
